<template>
  <div>
    <p class="hd-type-0n3">
      <span>雇用形態</span>
    </p>
    <p
      class="mt20"
      data-test="employment"
    >
      {{ requirements.employment.join(' ') }}
    </p>
    <p
      v-if="requirements.employmentRemarks"
      class="mt10 pega-pre-wrap"
      data-test="employmentRemarks"
      v-text="requirements.employmentRemarks"
    />
    <dl
      v-if="requirements.regular"
      class="bg-blue-box mt15"
      data-test="regular"
    >
      <dt>正社員登用について</dt>
      <dd
        class="pega-pre-wrap"
        v-text="requirements.regular"
      />
    </dl>

    <p class="hd-type-0n3">
      <span>給与</span>
    </p>
    <p
      class="mt20 pega-pre-wrap"
      data-test="salary"
      v-text="requirements.salary"
    />
    <dl
      v-if="requirements.salaryEx"
      data-test="salaryEx"
      class="bg-blue-box mt15"
    >
      <dt>給与例</dt>
      <dd
        class="pega-pre-wrap"
        v-text="requirements.salaryEx"
      />
    </dl>
    <dl
      v-if="requirements.isBulkRegistrationAddress && isMultiLineValue"
      data-test="isBulkRegistrationSalaryAddress"
      class="bg-blue-box mt15"
    >
      <dt>勤務地別給与</dt>
      <dd
        class="pega-pre-wrap pega-preview-word-break"
        v-text="requirements.combinedAllSalaryBulkPlace"
      />
    </dl>

    <p class="hd-type-0n3">
      <span>勤務地</span>
    </p>
    <p
      class="mt20 pega-pre-wrap"
      data-test="place"
      v-text="requirements.place"
    />
    <dl
      v-if="requirements.transportation"
      class="bg-blue-box mt15"
      data-test="transportation"
    >
      <dt>詳細・交通</dt>
      <dd
        class="pega-pre-wrap"
        v-text="requirements.transportation"
      />
    </dl>
    <dl
      v-if="requirements.transfer"
      class="bg-blue-box mt10"
      data-test="transfer"
    >
      <dt>転勤の可能性</dt>
      <dd
        class="pega-pre-wrap"
        v-text="requirements.transfer"
      />
    </dl>
    <job-preview-content-sub-work-location-sp
      v-if="requirements.isBulkRegistrationAddress && requirements.combinedAllBulkPlace"
      :is-bulk-registration-address="requirements.isBulkRegistrationAddress"
      :value-bulk-place="requirements.combinedAllBulkPlace"
      data-test="combinedAllBulkPlace"
    />
    <job-preview-content-sub-work-location-sp
      v-if="!requirements.isBulkRegistrationAddress"
      :work-location="requirements.workLocation"
      :is-bulk-registration-address="requirements.isBulkRegistrationAddress"
      data-test="workLocation"
    />

    <p class="hd-type-0n3">
      <span>応募資格</span>
    </p>
    <p
      class="mt20 pega-pre-wrap"
      data-test="requiredSkill"
      v-text="requirements.requiredSkill"
    />
    <dl
      v-if="requirements.welcomeSkill"
      class="bg-blue-box mt15"
      data-test="welcomeSkill"
    >
      <dt>あると望ましい経験・能力</dt>
      <dd
        class="pega-pre-wrap"
        v-text="requirements.welcomeSkill"
      />
    </dl>
    <dl
      v-if="requirements.recruitExample"
      data-test="recruitExample"
      class="bg-blue-box mt10"
    >
      <dt>過去に採用した転職者例</dt>
      <dd
        class="pega-pre-wrap"
        v-text="requirements.recruitExample"
      />
    </dl>

    <template v-if="isShow.post">
      <p
        class="hd-type-0n3"
        data-test="post-head"
      >
        <span>配属部署</span>
      </p>
      <p
        v-if="requirements.post"
        class="mt20 pega-pre-wrap"
        data-test="post"
        v-text="requirements.post"
      />
      <dl
        v-if="requirements.ageRatio"
        class="bg-blue-box mt10"
        data-test="ageRatio"
        :class="{'mt20':!requirements.post}"
      >
        <dt>年齢構成</dt>
        <dd
          class="pega-pre-wrap"
          v-text="requirements.ageRatio"
        />
      </dl>
      <dl
        v-if="requirements.sexRatio"
        class="bg-blue-box mt10"
        data-test="sexRatio"
        :class="{'mt20':!requirements.post&&!requirements.ageRatio}"
      >
        <dt>男女比</dt>
        <dd
          class="pega-pre-wrap"
          v-text="requirements.sexRatio"
        />
      </dl>
    </template>

    <p class="hd-type-0n3">
      <span>勤務時間</span>
    </p>
    <p
      class="mt20 pega-pre-wrap"
      data-test="officeHours"
      v-text="requirements.officeHours"
    />
    <dl
      v-if="requirements.overTime"
      data-test="overTime"
      class="bg-blue-box mt15"
    >
      <dt>残業について</dt>
      <dd
        class="pega-pre-wrap"
        v-text="requirements.overTime"
      />
    </dl>

    <template v-if="requirements.mother">
      <p
        class="hd-type-0n3"
        data-test="mother-head"
      >
        <span>育児と両立しやすい</span>
      </p>
      <p
        class="mt20 pega-pre-wrap"
        data-test="mother"
        v-text="requirements.mother"
      />
    </template>

    <p class="hd-type-0n3">
      <span>休日休暇</span>
    </p>
    <p
      class="mt20 pega-pre-wrap"
      data-test="vacation"
      v-text="requirements.vacation"
    />
    <dl
      v-if="requirements.maternity"
      class="bg-blue-box mt15"
      data-test="maternity"
    >
      <dt>産休育休活用例</dt>
      <dd
        class="pega-pre-wrap"
        v-text="requirements.maternity"
      />
    </dl>

    <p class="hd-type-0n3">
      <span>待遇・福利厚生・その他</span>
    </p>
    <p
      class="mt20 pega-pre-wrap"
      data-test="condition"
      v-text="requirements.condition"
    />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobPreviewContentSubWorkLocationSp from '@/components/atoms/JobPreviewContentSubWorkLocationSp'

export default {
  components: { JobPreviewContentSubWorkLocationSp },
  mixins: [jobPreviewCommon],
  props: {
    requirements: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMultiLineValue () {
      if (this.requirements.combinedAllSalaryBulkPlace) {
        return this.requirements.combinedAllSalaryBulkPlace.split('\n').length > 1
      }
      return false
    }
  }
}
</script>
